export function scrollToElementById(id: string, offset = 100) {
  const el = document.getElementById(id)
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY
    window.scrollTo({
      top: top - offset,
      behavior: 'smooth',
    })
  }
}
